goog.provide("shadow.js.shim.module$moment");
goog.provide("module$shadow_js_shim_module$moment");
shadow.js.shim.module$moment = shadow.js.nativeProvides["moment"] = require("moment");
module$shadow_js_shim_module$moment.default = shadow.js.shim.module$moment;
